export default __webpack_public_path__ + "static/media/mar-over-time.d8852d1a.png";